<template>
  <div style="height: inherit">
    <b-modal
      v-model="modalShowAssign"
      size="lg"
      :title="titleModalAssign"
      ok-title="Asignar"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      no-close-on-esc
      :busy="isBusyAssign"
      :hide-footer="true"
      @ok="okMdlAssign"
    >
      <b-overlay
        :show="isBusyAssign"
        rounded="sm"
      >
        <assign-user
          ref="refAssignForm"
          :is-busy-assign.sync="isBusyAssign"
          :modal-show.sync="modalShowAssign"
          :project="projectShow"
          :type-action="typeActionAssign"
          @refetch-data="refetchData"
          @error-data="showError"
        />
      </b-overlay>
    </b-modal>
    <proyecto-form
      :is-add-new-user-sidebar-active.sync="isAddNewSidebarActive"
      :form-type="formType"
      :data-edit="dataEdit"
      :img-logo="imgLogo"
      @refetch-data="refetchData"
      @error-data="showError"
    />
    <b-card
      no-body
      class="mb-0"
    >
      <b-card-body>
        <div
          v-if="isBusy"
          class="text-center text-primary my-2"
        >
          <b-spinner
            variant="primary"
            class="align-middle"
          />
          <strong class="ml-1">Cargando...</strong>
        </div>
        <!-- Overlay -->
        <div class="body-content-overlay" />

        <!-- Searchbar -->
        <div class="ecommerce-searchbar mt-1">
          <b-row>
            <b-col cols="12">
              <!-- dropdown in both side -->
              <b-input-group>
                <b-input-group-prepend>
                  <b-dropdown variant="outline-primary">
                    <template #button-content>
                      <feather-icon icon="FilterIcon" />
                    </template>
                    <!-- <b-dropdown-item>Proyecto </b-dropdown-item> -->
                  </b-dropdown>
                </b-input-group-prepend>
                <b-form-input
                  v-model="query"
                  placeholder="Buscar un proyecto...."
                />
                <b-input-group-append>
                  <b-button
                    variant="success"
                  >
                    Buscar
                  </b-button>
                  <b-button
                    variant="primary"
                    class="btn-block"
                    style="margin-left: 0.6%;"
                    @click="openForm('new')"
                  >
                    Nuevo
                  </b-button><!--  style="margin-left: 0.6%;"-->
                  <!-- <b-dropdown
                    text="Action"
                    variant="outline-primary"
                    right
                  >
                    <b-dropdown-item>Action </b-dropdown-item>
                    <b-dropdown-item>Another Action</b-dropdown-item>
                    <b-dropdown-item>Something else here</b-dropdown-item>
                    <b-dropdown-divider />
                    <b-dropdown-item>Separated link</b-dropdown-item>
                  </b-dropdown> -->
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
        </div>
        <!-- Encuestas -->
        <div
          v-if="itemsProject.length<=0 && !isBusy"
          class="text-center text-primary my-2"
        >
          <strong class="ml-1">No se encontraron ningún registro</strong>
        </div>
        <section class="grid-view">
          <b-card
            v-for="(proj, idProyecto) in itemsProject"
            :key="idProyecto"
            class="ecommerce-card"
            no-body
          >
            <b-card-header style="padding:0px !important">
              <b-card-title />
              <!-- Dropdown -->
              <div
                class="dropdownGrid"
              >
                <b-dropdown
                  variant="link"
                  no-caret
                  class="chart-dropdown"
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="18"
                      class="text-body cursor-pointer"
                    /><!-- style="background-color: yellow;text-align: center !important;position: absolute;top: 16px;" -->
                  </template>
                  <b-dropdown-item @click="getEdit(proj)">
                    Editar
                  </b-dropdown-item>
                  <b-dropdown-item @click="getDelete(proj)">
                    Eliminar
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <!-- <feather-icon
                icon="MoreVerticalIcon"
                size="18"
                class="cursor-pointer"
              /> -->
              <div
                class="item-img text-center"
                style="min-height: 0rem !important"
              >
                <b-link>
                  <b-img
                    :alt="`${proj.abreviatura}`"
                    fluid
                    class="card-img-top"
                    :src="isLoading ? imgLoading : proj.logo"
                  />
                </b-link>
              </div>
            </b-card-header>
            <!-- Product Details -->
            <b-card-body>
              <div class="item-wrapper">
                <!-- <div>
                  <feather-icon
                    icon="MessageCircleIcon"
                    size="21"
                    class="text-primary"
                    :badge="proj.totalPregunta"
                  />
                </div> -->
                <div>
                  <h6 class="item-price">
                    <feather-icon
                      icon="CalendarIcon"
                      class="mr-100"
                    />
                    {{ proj.createdAt }}
                  </h6>
                </div>
              </div>
              <h6 class="item-name">
                <b-link
                  v-b-tooltip.hover.top="proj.institucion.nombre"
                  class="text-body"
                >
                  {{ proj.institucion.nombre }}
                </b-link>
                <b-card-text class="item-company">
                  By <b-link class="ml-25">
                    HOLA
                  </b-link>
                </b-card-text>
              </h6>
              <b-card-text
                v-b-tooltip.hover.top="proj.nombre"
                class="item-description"
              >
                {{ proj.nombre }}
              </b-card-text>
            </b-card-body>
            <!-- Product Actions -->
            <div class="item-options text-center">
              <div class="item-wrapper">
                <div class="item-cost">
                  <h4 class="item-price">
                    *
                  </h4>
                </div>
              </div>
              <b-button
                variant="light"
                tag="a"
                class="btn-wishlist"
              >
                <feather-icon
                  icon="UserIcon"
                  size="18"
                />
                {{ proj.abreviatura }}
              </b-button>
              <b-button
                variant="primary"
                tag="a"
                class="btn-cart btn-block"
                @click="assignUser(proj)"
              >
                <feather-icon
                  icon="TrelloIcon"
                  class="mr-50"
                />
                <span>Asignar Encuestador</span>
              </b-button>
            </div>
          </b-card>
        </section>
        <!-- Pagination -->
        <section>
          <b-row>
            <b-col cols="12">
              <b-pagination
                v-model="page"
                :total-rows="totalitemsProject"
                :per-page="perPage"
                first-number
                align="center"
                last-number
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </section>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormInput, BInputGroup, BInputGroupAppend, BDropdown, BOverlay, BDropdownItem, BInputGroupPrepend, BButton, BCard, BLink, BImg, BCardBody, BCardText, BPagination, VBTooltip, BCardHeader, BCardTitle, BSpinner,
} from 'bootstrap-vue'
import store from '@/store'
import moment from 'moment'
import Ripple from 'vue-ripple-directive'
import ProyectoForm from './ProyectoForm.vue'
import AssignUser from './AssignUser.vue'
import loading1 from '../../../assets/images/encuesta/loading.gif'

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BInputGroupPrepend,
    BButton,
    BCard,
    BLink,
    BImg,
    BCardBody,
    BCardText,
    BPagination,
    BCardHeader,
    BCardTitle,
    ProyectoForm,
    BSpinner,
    AssignUser,
    // BDropdownDivider,
  },
  /* setup(){
    const {
      itemView, itemViewOptions, totalProducts,
    } = useShopUi()

  }, */
  data: () => ({
    isAddNewSidebarActiveAssign: false,
    userData: JSON.parse(localStorage.getItem('userData')),
    formTypeAssign: '',
    dataEditAssign: {},
    modalShowAssign: false,
    isBusyAssign: false,
    titleModalAssign: 'Clonación de Encuesta',
    typeActionAssign: 'new',
    totalitemsProject: 0,
    projectShow: 0,
    itemsProject: [],
    page: 1,
    perPage: 10,
    isAddNewSidebarActive: false,
    formType: '',
    dataEdit: {},
    imgLogo: null,
    total: 5,
    query: '',
    isBusy: false,
    imgLoading: loading1,
    isLoading: false,
  }),
  watch: {
    perPage: {
      handler() {
        this.listarRegistros()
      },
    },
    query: {
      handler() {
        this.listarRegistros()
      },
    },
    page: {
      handler() {
        this.listarRegistros()
      },
    },
  },
  mounted() {
    this.listarRegistros()
  },
  methods: {
    assignUser(proj) {
      this.modalShowAssign = true
      this.projectShow = proj
      this.titleModalAssign = 'Asignación de Usuarios'
      // this.$refs.refAssignForm.dataForm(proj)
    },
    okMdlAssign(ev) {
      ev.preventDefault()
      // refTratamientoForm.value.saveForm()
    },
    openForm(type) {
      this.formType = type
      this.isAddNewSidebarActive = true
      this.imgLogo = null
    },
    getEdit(data) {
      this.formType = 'edit'
      this.isAddNewSidebarActive = true
      this.dataEdit = data
      this.imgLogo = null
    },
    async listarRegistros() {
      this.itemsProject = []
      this.isBusy = true
      this.isLoading = true
      await store
        .dispatch('gsencuesta/PROYECTO_FIND_ALL', {
          limit: this.perPage,
          query: this.query,
          page: this.page,
          sortBy: 'idProyecto%7CDESC',
          // idInstitucion: -1,
          idInstitucion: this.userData.idInstitucion,
        })
        .then(response => {
          this.itemsProject = []
          response.items.forEach((dat, index) => {
            const ca = moment(dat.createdAt).format('DD/MM/YYYY')
            this.itemsProject.push({
              index,
              nombre: dat.nombre,
              idProyecto: dat.idProyecto,
              institucion: dat.institucion,
              longitud: dat.longitud,
              latitud: dat.latitud,
              nombreResponsable: dat.nombreResponsable,
              createdAt: ca,
              abreviatura: dat.abreviatura,
              logo: `https://apimesa.regionsanmartin.gob.pe/gsencuesta/api/v1/recurso/proyecto/${dat.idProyecto}`, // OPTIMIZAR
              estado: dat.estado,
            })
            this.totalitemsProject = response.totalItems
          })
          this.isBusy = false
          this.isLoading = false
        })
        .catch(error => {
          this.showError(error)
          this.isBusy = false
          this.isLoading = false
        })
    },
    getDelete(data) {
      this.$swal({
        title: '¿Está seguro de eliminar este registro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          console.log(data)
          store
            .dispatch('gsencuesta/PROYECTO_DELETE', {
              id: data.idProyecto,
            })
            .then(response => {
              this.listarRegistros()
              this.$bvToast.toast('Ha Eliminado correctamente el registro.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error.response.data.errorMessage, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.listarRegistros()
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.errorMessage
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group ::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}
/* .ecommerce-application .grid-view {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr !important;
    -webkit-column-gap: 2rem;
    -moz-column-gap: 2rem;
    column-gap: 2rem;
} */
[dir] .ecommerce-application .grid-view .ecommerce-card .item-img {
    padding-top: 0.0rem !important;
}
.dropdownGrid{
  background-color: #F8F8F8!important;
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 5%!important;
  /*position: absolute!important;
  left: 93.5% !important;
  top: 0px!important;
  opacity: .9!important;*/
}
</style>
